import ShoppingCartTwoToneIcon from '@mui/icons-material/ShoppingCartTwoTone';
import React from 'react';
import './Card.css';

const Card = ({ cake, addToCart }) => {
    const { img, name, id, price } = cake;
    return (
        <div className='card'>
            <img 
            className='card-img'
            src={img}
            alt="" />
            <div className="card-info">
            <h3>{name}</h3>
           <div className='price-div'>
            <span className='price'>${price}</span>
            <span className='id'>ID: {id}</span>
           </div>
            <button
            className='add-cart-btn'
            onClick={() => {
                addToCart(cake)
            }}>
                <span>Add To Cart </span>
                <ShoppingCartTwoToneIcon
                className='cart-icon'
            color='primary'
            fontSize='small'/></button>
            </div>

        </div>
    );
};

export default Card;